import React from 'react';
import { DataForDesignDrawingsManifold } from '../../designs/data-for-design-drawings/dataForDesignDrawingsResponse';
import { DisplayStyle } from './templates/DisplayStyle';
import { PortOrRoomRow } from './templates/PortOrRoomRow';

type Props = {
  manifold: DataForDesignDrawingsManifold;
  displayStyle?: DisplayStyle;
};
export const RoomTemperatureRow = ({ manifold, displayStyle = 'PerPort' }: Props) => {
  return (
    <PortOrRoomRow
      name="Room Temperature (°C)"
      manifold={manifold}
      getValue={room => room.roomTemperatureInDegreesCelsius}
      displayStyle={displayStyle}
    />
  );
};
